// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"57a11544","693":"e4ebe356"}[chunkId] + ".chunk.js";
};